module.exports = __webpack_public_path__ + "img/prime_steel_logo.d2fe86d2.png";